/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Component } from "@angular/core";
import { HideableColumnService } from "./providers/hideable-column.service";
var DatagridCell = (function () {
    function DatagridCell(hideableColumnService) {
        this.hideableColumnService = hideableColumnService;
    }
    Object.defineProperty(DatagridCell.prototype, "hidden", {
        /**
         * @property hidden
         *
         * @description
         * Property used to apply a css class to this cell that hides it when hidden = true.
         *
         * @type {boolean}
         */
        get: function () {
            var column = this.hideableColumnService.getColumnById(this.id);
            return (column) ? column.hidden : false;
        },
        enumerable: true,
        configurable: true
    });
    return DatagridCell;
}());
export { DatagridCell };
DatagridCell.decorators = [
    { type: Component, args: [{
                selector: "clr-dg-cell",
                template: "\n        <ng-content></ng-content>\n    ",
                host: {
                    "[class.datagrid-cell]": "true",
                    "[class.datagrid-cell--hidden]": "hidden"
                }
            },] },
];
/** @nocollapse */
DatagridCell.ctorParameters = function () { return [
    { type: HideableColumnService, },
]; };
//# sourceMappingURL=datagrid-cell.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/data/datagrid/datagrid-cell.js
// module id = 49
// module chunks = 4